import { render } from "./PlanHeadingWrapper.vue?vue&type=template&id=42dd5114&scoped=true"
import script from "./PlanHeadingWrapper.vue?vue&type=script&lang=js"
export * from "./PlanHeadingWrapper.vue?vue&type=script&lang=js"

import "./PlanHeadingWrapper.vue?vue&type=style&index=0&id=42dd5114&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42dd5114"]])

export default __exports__